import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setIsChangeCustomTrigger: Function // function to toggle custom trigger
    setChangeCustomTriggerId: Function // function to set custom trigger Id
}

// component to render widget custom trigger
const CustomTrigger = (props: PropTypes) => {

    // Props
    const { setIsChangeCustomTrigger, setChangeCustomTriggerId } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    // Stets
    const [customTrigger, setCustomTrigger] = useState<boolean>(false);
    const [customTriggerId, setCustomTriggerId] = useState<string>('');

    // Show information popup
    const [isShowInfoModal, setIsShowInfoModal] = useState<boolean>(false);

    const [errorMessage, setErrorMessage] = useState<string>('');

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if custom trigger is turned On
            if (currentWebsite.is_custom_trigger) {
                setCustomTrigger(currentWebsite.is_custom_trigger);
            }
            if (currentWebsite.custom_trigger_id) {
                setCustomTriggerId(currentWebsite.custom_trigger_id);
            }
        }
    }, [currentWebsite]);



    // set current statement link in prop function
    useEffect(() => {
        setIsChangeCustomTrigger(customTrigger);
    }, [customTrigger]);


    useEffect(() => {
        if (customTriggerId) {
            setChangeCustomTriggerId(customTriggerId)
        }
    }, [customTriggerId]);


    const validateId = (id: string) => {
        setCustomTriggerId(id);
        // let filteredId = id.replace(/^([#.])/, '');


        // const regx = /^[A-Za-z][A-Za-z0-9\-\_\:\.]*$/;

        // if (regx.test(filteredId)) {
        //     setErrorMessage("");
        // }
        // else {
        //     setErrorMessage(t("Invalid Id Error"));
        // }
        

    }

     // function to show information modal
    const handleShowInfoModal = (type: number) => {
        setIsShowInfoModal(true);
    }

    // function to hide information modal
    const handleHideInfoModal = () => {
        setIsShowInfoModal(false);
    }


    return (
        <>
            <div className="aioa_dashboard-widget-settings-controls">
                <div className={customTrigger ? "aioa_dashboard-widget-custom-settings border-bottom" : ''}>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="custom-trigger-switch"
                        label={`${t('Enable Custom Accessibility Trigger')}`}
                        checked={customTrigger}
                        onChange={(e) => setCustomTrigger(!customTrigger)}
                    />
                </div>
                {customTrigger ?
                    <>
                        <Form.Group className="custom-statement" controlId="custom_accessibility_trigger_id">
                            <Form.Label>{t('Enter a custom accessibility trigger using an ID, selector, or XPath.')}</Form.Label>  
                            <Button variant="link" className="info-btn" aria-label={t("Learn more about Custom Accessibility Trigger").toString()} onClick={() => handleShowInfoModal(3)}>
                                <i className="material-symbols-outlined" aria-hidden="true">info</i>
                            </Button>
                            <Form.Control
                                size="lg"
                                type="text"
                                placeholder={("Custom Trigger Id")}
                                defaultValue={customTriggerId}
                                onChange={(e) => validateId(e.target.value)}
                            />
                        </Form.Group>
                        {errorMessage && (
                            <>
                                <div className="text-danger"><strong>{errorMessage}</strong></div>
                            </>
                        )}
                    </>
                    : <></>
                }
                {/* Show Info Modal */}
                <Modal show={isShowInfoModal} onHide={() => handleHideInfoModal()} fullscreen="sm-down" backdrop="static" centered>
                    <Modal.Header closeButton>
                    <Modal.Title>
                        <>{t('Custom Accessibility Trigger')}</>
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t('Enter a custom trigger identifier that can be:')}</p>
                        <ul>
                        <li>{t('An')} <strong>{t('ID')}</strong> ({t('e.g')}, <code>my-button</code>)</li>
                        <li>{t('A')} <strong>{t('CSS selector')}</strong> ({t('e.g')}, <code>.my-class</code>)</li>
                        <li>{t('An')} <strong>{t('XPath')}</strong> ({t('e.g')}, <code>//button[@id='my-button']</code>)</li>
                        </ul>
                    </Modal.Body>
                </Modal>

            </div>
        </>
    )
}

export default CustomTrigger;